export default __webpack_public_path__ + "static/media/logo2.3728bcca.png";